import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { showApiErrorToast } from '@/utils/errors';
import { deleteRole, roleQueryKeys } from '../api/roles.api';

export function useDeleteRole() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: number) => deleteRole(id),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: roleQueryKeys.all() });
      toast.success('Role deleted successfully');
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to delete role');
    },
  });
}
